import { render, staticRenderFns } from "./GroupCpm.vue?vue&type=template&id=796c692f&scoped=true&"
import script from "./GroupCpm.vue?vue&type=script&lang=js&"
export * from "./GroupCpm.vue?vue&type=script&lang=js&"
import style0 from "./GroupCpm.vue?vue&type=style&index=0&id=796c692f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796c692f",
  null
  
)

export default component.exports